import { useState, useCallback } from 'react'
import useDebounce from './useDebounce'

interface UseDebouncedSearchProps {
  debounceDelay?: number
  minLength?: number
  maxLength?: number
}

export const useDebouncedSearch = ({ 
  debounceDelay = 300, 
  minLength = 2, 
  maxLength = 50 
}: UseDebouncedSearchProps = {}) => {
  const [searchValue, setSearchValue] = useState('')
  const debouncedSearchValue = useDebounce(searchValue, debounceDelay)
  
  const updateSearch = useCallback((value: string) => {
    setSearchValue(value)
  }, [])
  
  const shouldTriggerSearch = debouncedSearchValue.length >= minLength && 
                             debouncedSearchValue.length <= maxLength
  
  const clearSearch = useCallback(() => {
    setSearchValue('')
  }, [])
  
  return {
    searchValue,
    debouncedSearchValue: shouldTriggerSearch ? debouncedSearchValue : '',
    updateSearch,
    clearSearch,
    shouldTriggerSearch
  }
}